import { theme } from '@frontend/theme';
import { DirectAvailabilityCheck } from '../../components/DirectAvailabilityCheck';
import { ProviderAppointmentHours } from '../../components/provider-appointment-hours';
import { ScheduleBanner } from '../../components/ScheduleBanner';
import { scheduleDirectAvailabilityBannerText } from '../../constants';

const { providerScheduleDirectAvailabilityTitle, providerScheduleDirectAvailabilityMessage } =
  scheduleDirectAvailabilityBannerText;

type Props = {
  providerId: string;
  locationId: string;
};

export const ProviderScheduleV3Page = ({ providerId, locationId }: Props) => {
  return (
    <section css={{ padding: theme.spacing(2) }}>
      <DirectAvailabilityCheck locationId={locationId} css={{ marginTop: theme.spacing(2) }}>
        <ScheduleBanner
          fullWidth
          title={providerScheduleDirectAvailabilityTitle}
          message={providerScheduleDirectAvailabilityMessage}
        />
      </DirectAvailabilityCheck>
      <ProviderAppointmentHours locationId={locationId} providerId={providerId} />
    </section>
  );
};
